import React from "react";
import { useSearchParams } from "react-router-dom";
import TimeEntries from "./TimeEntries";

const TimeEntriesPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  let date = searchParams.get("date");
  return <TimeEntries isoDateParam={date} />;
};

export default TimeEntriesPage;
